import { EditHealthCertificateFormDto, mapToEditHealthCertificateFormDto } from "../healthCertificates/editHealthCertificateFormDto";
import { DefaultIndicatorsDto, emptyIndicators } from "../medicalIndicators/defaultIndicatorsDto";
import { UserShortDto, emptyUser } from "../users/userShortDto";
import { DriverDto } from "./driverDto";

/**
 * Interface representing a driver create/edit form.
 */
export interface EditDriverFormDto {
  id: number | null;
  user: UserShortDto;
  employeeNumber: string;
  snils: string | '';
  licenceSerial: string | '';
  licenceNumber: string | '';
  licenceIssued: Date | null;
  licenceExpired: Date | null;
  passportSerial: string | '';
  passportNumber: string | '';
  defaultIndicators: DefaultIndicatorsDto;
  companyId: number | null;
  healthCertificates: EditHealthCertificateFormDto[];
}

export const emptyEditDriverFormDto = (companyId?: number, defaultIndicators: DefaultIndicatorsDto = emptyIndicators): EditDriverFormDto => {
  return {
    id: null,
    user: emptyUser,
    employeeNumber: '',
    snils: '',
    licenceSerial: '',
    licenceNumber: '',
    licenceIssued: null,
    licenceExpired: null,
    passportSerial: '',
    passportNumber: '',
    defaultIndicators,
    companyId: companyId ? companyId : null,
    healthCertificates: [],
  }
};

export const mapToEditDriverFormDto = (driverDto: DriverDto): EditDriverFormDto => {
  return {
    id: driverDto.id,
    user: driverDto.user,
    employeeNumber: driverDto.employeeNumber,
    snils: driverDto.snils,
    licenceSerial: driverDto.licenceSerial,
    licenceNumber: driverDto.licenceNumber,
    licenceIssued: driverDto.licenceIssued,
    licenceExpired: driverDto.licenceExpired,
    passportSerial: driverDto.passportSerial,
    passportNumber: driverDto.passportNumber,
    defaultIndicators: driverDto.defaultIndicators,
    companyId: driverDto.company?.id ?? null,
    healthCertificates: driverDto.healthCertificates.map(mapToEditHealthCertificateFormDto)
  }
};
